<template>
  <div v-if="searchResultStore.searchResultState.status === 'success'">
    <TsSearchResults search-type="direct-search" :bannerData="algoliaStore.bannerData"></TsSearchResults>
  </div>
  <div v-if="searchResultStore.searchResultState.status === 'failed'">
    <TsNoResultFound></TsNoResultFound>
  </div>
  <div v-if="searchResultStore.searchResultState.status === 'loading'">
    <TsSearchPageLoading :search-query="getSearchQueryFromRoute()"></TsSearchPageLoading>
  </div>
  <div v-if="searchResultStore.searchResultState.status === 'idle'">
    <TsSearchPageLoading :search-query="getSearchQueryFromRoute()"></TsSearchPageLoading>
  </div>

  <TsSection container-class="px-0"  id="plp-search-recommendations" > 
  
    <TsTypography as="h2" variant="h1" append-class="mb-2" v-if="monetateStore.search_recommendations.ids?.length" > 
      {{useTranslation('recentlyViewed' , 'Laatst bekeken')}} </TsTypography>
        <div class="lg:-mx-1.5" >
          <TsCarouselCardProduct
              @product-click="monetateStore.trackRecommendationClick(appRegion,monetateStore.search_recommendations, $event)"
              data-testid="product-others-carousel"
              productContextType="recommended" 
              :productIds="monetateStore.search_recommendations.ids"
              
          />
        </div>


    </TsSection>
</template>

<script setup lang="ts">
const TsSearchResults = defineAsyncComponent(() => import('~/components/organisms/TsSearchResults.vue'));
const TsNoResultFound = defineAsyncComponent(() => import('~/components/organisms/TsNoResultFound.vue'));
const TsSearchPageLoading = defineAsyncComponent(() => import('~/components/organisms/TsSearchPageLoading.vue'));
const TsCarouselCardProduct = defineAsyncComponent(() => import('~/components/organisms/TsCarouselCardProduct.vue'));

const { useTranslation } = await import("~/composables/useTranslation");
const nuxtApp = useNuxtApp();
const searchResultStore = useSearchResultStore();
const config = useRuntimeConfig();
const route = useRoute();
const monetateStore = useMonetateStore();
const algoliaStore = useAlgoliaStore();
const {locale} = useI18n();
const {isMobile,isDesktop} = useDevice();
const appRegion = config.public.appRegion;

const { builderApiKey } = useRuntimeConfig().public

const rootStore = useRootStore();
const searchResultsFor = useTranslation('SearchResultsFor', 'Zoekresultaten voor');
const productListingPage = useTranslation('ProductListingPage', 'Productvermeldingspagina');
const productListingPageFor = useTranslation('ProductListingPageFor', 'Productvermeldingspagina voor');

onMounted(async () => {
  rootStore.page_background_color = null;
  rootStore.page_background_color = "#F7FBFE";
});

// Create a computed property that combines the query and the trigger
const watchedQuery = computed(() => ({
  query: route.query,
  trigger: searchResultStore.isWatchTrigger,
}))

const stopWatcher = watch(
  watchedQuery,
  async (newVal, oldVal) => {
    const oldQuery = oldVal.query || {};
    const newQuery = newVal.query || {};

    const layoutChanged = oldQuery.layout !== newQuery.layout;

    // Check if any other property has changed
    const otherQueriesChanged = Object.keys(newQuery).some(
      (key) => key !== "layout" && newQuery[key] !== oldQuery[key]
    );

    // If only the layout has changed, return
    if (layoutChanged && !otherQueriesChanged) {
      return;
    }

    setMetaTags();
    getBrandData();
    scrollToTop();

    await searchResultStore.onLoadPlp(route,"direct-search",null,locale.value,isMobile,isDesktop,config,nuxtApp);
    await searchResultStore.fetchStockOfProduct();
  }
);
 
onUnmounted(() => {
  productList.value = null
  searchResultStore.products = [];
  algoliaStore.productIDs = [];
  stopWatcher();
});

async function getBrandData() {
    const {getItem} = await import("~/services-optimized/builderService");
    algoliaStore.bannerData  = await getItem(builderApiKey,'products-listing', { urlPath: route.path }, {},
        {'data.query.$regex': String(route.query?.q).replace(/\s+/g, ' ')},nuxtApp)
}


const { data: productList, pending, error } = await useLazyAsyncData("search-plp", async () =>{
  return searchResultStore.onLoadPlp(route,"direct-search",null,locale.value,isMobile,isDesktop,config,nuxtApp)
}, {
  dedupe: "cancel",
});


if(error.value){
  throw createError(error.value);
}


await useAsyncData(`search-plp-stock`,
    () => {
      if(!productList.value ){
        return;
      }
      return searchResultStore.fetchStockOfProduct(nuxtApp,config)
    },
    {
      lazy:true,
      watch:[productList],
      dedupe: "cancel",
    })

await useAsyncData(`search-plp-banner`,
    () => getBrandData().then(() => true),
    {
      lazy:true,
      watch:[productList],
      dedupe: "cancel",
    })

setMetaTags();

const getSearchQueryFromRoute = () => {
  return (route.query.q as string) || ("" as string);
};

function setMetaTags() {
  useHead({
    title:
      "Toolstation | " +
      (route.query.q
        ? `${searchResultsFor} ${route.query.q}`
        : `${productListingPage}`),
    meta: [
      {
        name: "description",
        content: `${productListingPageFor} ${
          (route.query.q as string) || ("" as string)
        }`,
      }, 
      {
        name: "title",
        content: "Toolstation | " +
        (route.query.q
        ? `${searchResultsFor} ${route.query.q}`
        : `${productListingPage}`),
      },
    ],
  });
}
</script>
